import type { FunctionComponent } from "react";

import {
  BottomClickableArea,
  LeftClickableArea,
  RightClickableArea,
  TopClickableArea,
} from "./styles";

export type Props = {
  handleGoToNextPage: () => void;
  handleGoToPreviousPage: () => void;
};

export const AdFloatClickableArea: FunctionComponent<Props> = ({
  handleGoToNextPage,
  handleGoToPreviousPage,
}) => (
  <>
    <TopClickableArea onClick={handleGoToNextPage} />
    <BottomClickableArea onClick={handleGoToNextPage} />
    <LeftClickableArea onClick={handleGoToPreviousPage} />
    <RightClickableArea onClick={handleGoToNextPage} />
  </>
);
